import _ from "lodash";
import React, { memo } from "react";
import { useSortable } from "@dnd-kit/sortable";
import PropTypes from "prop-types";
import TableCell from "./TableCell";

const DraggableCell = props => {
  const { cell, colRefsAndHandlers, header, isDraggable } = props;

  const columId = _.get(cell, ["column", "id"]);

  const {
    setNodeRef,
    attributes,
    listeners,
    node,
    setActivatorNodeRef,
  } = useSortable({
    id: columId,
    disabled: !isDraggable,
  });

  if (isDraggable) {
    colRefsAndHandlers.current[columId] = {
      id: columId,
      listeners,
      attributes,
      ref: node,
      setActivatorNodeRef,
    };
  }

  const style = {
    ...(header && { width: header.getSize() }),
  };

  return (
    <TableCell
      {...props}
      setNodeRef={!isDraggable ? undefined : setNodeRef}
      dragAttributes={attributes}
      dragListeners={listeners}
      tableCellStyles={style}
    />
  );
};

DraggableCell.defaultProps = {
  isDraggable: false,
};

DraggableCell.propTypes = {
  cell: PropTypes.object,
  colRefsAndHandlers: PropTypes.object,
  header: PropTypes.object,
  isDraggable: PropTypes.bool,
};

export default memo(DraggableCell);
